import React from 'react';
import { flowRight } from 'lodash';
import type { ELSPropsFromToastService } from '@els/els-component-toast-react';
import withHTMLHeadSEO from '../../hocs/with-html-head-seo/withHTMLHeadSEO.hoc';
import withRemediationBase from '../../hocs/with-remediation-base/withRemediationBase.hoc';
import RecommendationPostPlayer from './RemediationPostPlayer.component';
import { RecordEmpty } from '../../models/common.models';

const enhance = flowRight(
  withHTMLHeadSEO({ title: 'Remediation' }),
  withRemediationBase(),
);

const RemediationPostPlayerPage = enhance(RecommendationPostPlayer as unknown as React.ComponentType<ELSPropsFromToastService>) as React.FC<RecordEmpty>;

export default RemediationPostPlayerPage;
